import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";
import { Router, ActivatedRoute } from "@angular/router";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-admin-verification",
  templateUrl: "./admin-verification.component.html",
  styleUrls: ["./admin-verification.component.css"]
})
export class AdminVerificationComponent implements OnInit {
  isSuccess: boolean = false;
  isFailure: boolean = false;
  tokenValue: any = "";
  successMsg: any = "";
  failureMsg: any = "";
  errorMsg: any = "";

  constructor(
    private _restService: RestService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.tokenValue = this.route.snapshot.paramMap.get("token");
    this._restService.verifyAdminTransfer(this.tokenValue)
    .pipe(
      catchError(e => {
        console.log("err --->", e);
        this.isFailure = true;
        this.failureMsg = e.error.StatusInfo;
        return e;
      })
    )
    .subscribe(
      (f: any) => (
        ((this.isSuccess = true),
        (this.successMsg = "Admin Transfer Succeessful"),
        setTimeout(() => {
          localStorage.clear();
          this.router.navigate([""]);
        }, 5000))
      )
    );
  }
}
